export default "__VITE_ASSET__4DCtzlZj__"